// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const Icon = require('client-v2/common/containers/icons/component')
// Sibling imports
const AuthSection = require('../containers/auth-section/component-smart')

const bem = BemEntity('FeedSection')

function FeedSection() {
  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('logo-container')
      },
        tag(Icon, {
          className: bem.element('logo-icon'),
          id: 'mix-logomark'
        }),
        tag(Icon, {
          className: bem.element('logo-text'),
          id: 'mix-logotype'
        })
      ),
      tag('div', {
        className: bem.element('inner')
      },
        tag('div', {
          className: bem.element('text-wrapper')
        },
          tag('div', {
            className: bem.element('title')
          },
            tag('span', {
              className: bem.element('title-emphasis')
            },
              `Rediscover `
            ),
            `the internet.`
          ),
          tag('div', {
            className: bem.element('subtitle')
          },
            `Mix is a new personalized discovery platform that
            unlocks more of the internet you care about.`
          ),
          tag(AuthSection)
        ),
        tag('div', {
          className: bem.element('feed-image')
        })
      )
    )
  )
}

module.exports = FeedSection
